import apiClient from "../axios.config";
import { setAuthTokens } from "../../utils/authTokens";

const ownerOtpLogin = {
  /**
   * Step 1: Request OTP for owner login
   * @param {string} mobNo - Mobile number
   */
  requestOtp(mobNo) {
    return apiClient.post(`/owner/auth/login?mobNo=${mobNo}`);
  },

  /**
   * Step 2: Resend OTP for owner login
   * @param {string} mobNo - Mobile number
   */
  resendOtp(mobNo) {
    return apiClient.post(`/owner/auth/login/resend-otp?mobNo=${mobNo}`);
  },

  /**
   * Step 3: Verify OTP and store access + refresh tokens
   * @param {string} mobNo - Mobile number
   * @param {string} otp - 4-digit OTP
   */
  verifyOtp(mobNo, otp) {
    return apiClient
      .post(`/owner/auth/login/verify-otp?mobNo=${mobNo}&otp=${otp}`)
      .then((response) => {
        if (response.data && response.data.result) {
          const { accessToken, refreshToken, role } = response.data.result;
          if (accessToken) {
            setAuthTokens({
              accessToken,
              refreshToken,
              role: role || "O",
              accessExpires: 7,
              refreshExpires: 7,
            });
          }
        }
        return response.data;
      });
  },
};

export default ownerOtpLogin;
